module.exports = __webpack_public_path__ + "img/edit-photo.5fe6f191.svg";